// extracted by mini-css-extract-plugin
export default {"customTablesWrap":"_3LDQCGYSyIOCfxI0HTmlh7","ctHead":"_2r1mou_oaiGNsSCvjb-fWi","ctName":"_1g28qn69usCSpiTuoEBep7","ctEmpty":"_2S3V-wpucxlTVFyZBGRP7J"};